module.exports = __webpack_public_path__ + "img/1.9e7f2fdc.png";